import React, { useMemo } from "react";

import { DiaryContainer } from "../../shared/DiaryContainer";
import { DiaryHeader } from "../../shared/DiaryHeader";
import Skeleton from "Components/Generic/Skeleton";
import { sub, add, getDayOfYear, getYear } from "date-fns";
import { Event } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { getDiaryEventsFromDespatchTasks, orderByDate } from "Util/calendar";
import { getDateList } from "Util/getDateList";

import { CalendarEvent } from "../../../../../../components/DiaryCalendar";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import CollapsablePanel from "./Panel";
import useStyles from "./styles";
import { useAppState } from "Context/StateContext";

const DATE_RANGE = 3;

export const DiaryListView = React.forwardRef(() => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const today: Date = useMemo(() => new Date(), []);
  const { tasksFiltered, isFetchingTasks, seeTasksModalRef } = useOperationDespatchContext();
  const { formatWithUserTimezone } = useAppState();

  const events = useMemo(() => {
    return getDiaryEventsFromDespatchTasks(tasksFiltered);
  }, [tasksFiltered]);

  const dateList: Date[] = useMemo(() => {
    const firstDay = sub(today, { days: DATE_RANGE });
    const lastDay = add(today, { days: DATE_RANGE });

    return getDateList(firstDay, lastDay);
  }, []);

  const getEventsByDate = (date: Date) => {
    const dayEvents = events?.filter(
      (event: Event) =>
        event.start &&
        getDayOfYear(event.start) === getDayOfYear(date) &&
        getYear(event.start) === getYear(date)
    );

    return orderByDate(dayEvents);
  };

  const onSeeTasks = (allEvents: CalendarEvent[], date?: Date) => {
    const taskResources = allEvents.map((event) => event?.resource?.task)?.filter(Boolean);

    seeTasksModalRef.current?.open(taskResources, date);
  };

  return (
    <DiaryContainer>
      <DiaryHeader title={translate("taskList")} />

      <div className={classes.body}>
        <Skeleton classesName={classes.skeleton} isLoading={isFetchingTasks}>
          <div>
            {dateList?.map((date: Date, index: number) => (
              <CollapsablePanel
                key={index}
                order={index}
                date={date}
                events={getEventsByDate(date)}
                title={formatWithUserTimezone(date, "EEEE, MMMM dd")}
                onSelectEvent={(event) => onSeeTasks([event])}
              />
            ))}
          </div>
        </Skeleton>
      </div>
    </DiaryContainer>
  );
});
